var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _ellipse, _ellipse2, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1128,
    height: 641,
    viewBox: "0 0 1128 641",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276.443 70.061C282.443 62.461 286.61 66.8943 287.943 70.061C291.143 75.261 300.276 83.561 304.443 87.061C307.243 100.661 291.943 123.728 283.943 133.561C283.943 145.561 301.61 156.894 310.443 161.061V169.061C286.843 161.061 252.61 203.394 238.443 225.561C208.443 188.561 215.943 167.061 223.943 142.561C230.343 122.961 261.61 86.061 276.443 70.061Z",
    fill: "#223B41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M382.943 96.561C372.543 106.161 344.943 101.894 332.443 98.561C340.043 113.361 360.61 122.061 369.943 124.561C368.743 139.761 354.443 153.561 347.443 158.561V166.561C362.243 166.161 377.277 193.728 382.943 207.561C409.743 155.961 394.11 112.061 382.943 96.561Z",
    fill: "#223B41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M388.943 69.561C397.943 43.561 370.065 -6.45683 325.443 4.56095C284.943 14.561 277.61 53.561 278.943 70.061C280.143 64.061 287.943 62.061 295.943 66.061C357.143 102.461 383.443 83.561 388.943 69.561ZM388.943 69.561C394.776 73.7277 401.743 85.061 382.943 97.061C364.143 109.061 324.776 96.7277 307.443 89.061C301.6 85.7277 288.919 76.461 284.943 66.061",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M329.443 4.56097C338.592 14.7876 353.058 44.705 337.729 82.561",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M342.443 3.56097C350.982 13.8986 364.484 47.2943 350.177 85.561",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M282.943 135.061C298.61 158.728 339.543 189.961 369.943 125.561",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 314.443,
    cy: 118.561,
    r: 3,
    fill: "#223B41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.443,
    cy: 121.561,
    r: 3,
    fill: "#223B41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M307.443 111.561C308.277 109.561 311.643 105.861 318.443 107.061",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M339.443 113.561C339.61 112.061 340.743 109.061 343.943 109.061",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M322.443 149.009C325.391 149.653 332.317 150.265 336.443 147.561",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M330.943 115.061C330.11 117.894 329.843 124.661 335.443 129.061C342.443 134.561 333.443 135.561 326.443 135.061",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M311.443 161.612V167.715C319.443 171.203 337.643 175.475 346.443 164.664V158.561",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M310.943 168.561C293.443 169.061 251.843 187.861 225.443 259.061C222.11 268.728 221.843 291.061 247.443 303.061M252.943 281.061C244.11 330.394 228.543 433.161 236.943 449.561C245.343 465.961 361.11 453.061 417.943 444.561",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M414.943 445.061C422.943 444.061 424.943 441.561 419.443 432.061C412.496 420.061 396.443 372.561 400.943 333.061M387.443 221.061C380.943 203.394 363.843 167.461 347.443 165.061",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M268.443 477.612C275.243 475.612 276.61 462.394 275.943 458.561H300.443C300.043 465.761 298.277 484.561 297.443 493.061C296.959 498 284.943 503.161 260.943 505.561C236.943 507.961 237.943 500.561 237.943 497.061C237.943 477.561 269.11 474.228 275.943 480.061",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M391.443 465.561C393.44 464.519 396.056 463.764 398.943 463.313M398.943 463.313C412.685 461.169 432.599 465.926 421.443 479.561C410.643 492.761 360.943 496 360.943 486.561L362.443 452.561L393.443 448.561C391.843 453.761 396.443 460.562 398.943 463.313Z",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M280.443 265.061C285.243 264.661 285.11 267.561 284.443 269.061C282.61 273.561 275.443 282.461 261.443 282.061C247.443 281.661 243.277 272.561 242.943 268.061C246.443 245.061 265.943 237.061 267.443 237.061C268.943 237.061 283.943 232.061 284.443 237.061C284.843 241.061 279.277 242.061 276.443 242.061C272.61 242.728 265.696 245.061 269.296 251.061M264.943 271.561L281.943 264.061C284.61 263.394 289.243 260.961 286.443 256.561C283.643 252.161 273.277 258.394 268.443 262.061M269.296 251.306C275.129 248.239 288.043 244.299 286.443 254.061",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M289.943 207.561L286.943 217.561",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M694.943 202C696.443 203.667 702.443 204.961 712.443 202.561M710.943 202.895C712.777 205.062 720.343 206.761 727.943 201.561C735.543 196.361 734.777 190.728 733.443 188.561C733.217 188.141 732.884 187.704 732.443 187.321C734.443 182.33 732.056 178.401 730.613 177.061M719.971 192.061C717.962 189.894 715.643 184.961 722.443 182.561C726.126 181.261 728.801 179.121 730.613 177.061M733.443 172.561C733.061 173.631 732.147 175.317 730.613 177.061M691.443 178.061C693.843 172.061 702.777 165.228 706.943 162.561C713.943 158.228 729.743 150.861 736.943 156.061C739.61 158.061 742.143 162.761 730.943 165.561L723.943 167.061M709.943 176.561C710.61 180.561 709.643 190.061 700.443 196.061M725.443 167.061C728.443 166.228 733.443 167.061 733.443 172.061",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M732.443 187.061C729.943 187.228 722.843 189.761 714.443 196.561",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M700.943 168.061C702.443 169.228 707.043 171.361 713.443 170.561C721.443 169.561 721.943 175.061 720.443 177.561C719.243 179.561 714.277 179.061 711.943 178.561",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M503.443 316.561C498.101 320.835 484.091 327.513 467.943 323.076M464.943 314.561C459.343 316.961 462.277 320.561 463.443 321.561C464.958 322.167 466.46 322.668 467.943 323.076M467.943 323.076C467.943 318.238 469.443 309.061 475.443 311.061M475.443 316.561C477.11 311.394 481.943 302.061 487.943 306.061M484.443 314.561C485.443 311.228 488.843 305.661 494.443 310.061M492.443 315.561C494.61 312.389 499.843 307.749 503.443 314.561",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M505.943 474.061C506.777 475.561 507.543 480.061 503.943 486.061M508.443 488.561C499.443 485.728 470.943 488.561 478.443 509.061",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M531.943 471C535.943 480.667 538.643 500.9 517.443 504.5C496.243 508.1 479.943 513.5 478.443 509",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M572.944 467.561C570.777 478.728 569.144 501.461 579.944 503.061C593.444 505.061 626.944 509.061 635.944 499.561C644.944 490.061 620.944 477.561 605.444 484.561M600.944 473.561C604.11 476.561 606.944 481.061 603.444 489.561",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M614.943 303C608.943 305.8 596.11 307.833 590.443 308.5L592.443 319.5C590.843 323.1 577.11 321 570.443 319.5C524.043 309.1 507.443 313.833 504.943 317.5C485.443 334.5 481.533 405.922 482.443 440.5C483.443 478.5 506.943 476.333 520.943 476C547.943 473.5 550.277 454.333 553.443 444.5C563.443 475.7 590.943 479.167 602.943 476C614.11 471 629.273 460.491 627.943 437C626.443 410.5 615.777 336.333 614.943 303Z",
    fill: "#223B41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M535.943 207C534.943 208.333 533.243 212 534.443 216",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M484.443 212.5C492.277 193.167 508.443 166 549.443 161.5",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M593.943 175C595.943 175.833 604.943 177.5 606.443 188.5",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M684.943 176.5C692.777 176.833 705.143 183.3 691.943 206.5C678.743 229.7 633.443 248.5 612.443 255",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M611.943 255.181C613.61 266.681 613.943 292.381 611.943 305.181M689.443 177C681.61 175.5 655.543 175.181 633.943 187.181C627.443 190.515 614.143 196.6 606.943 189",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M535.202 115.242C545.84 109.429 552.009 118.972 553.764 124.47C568.485 115.152 572.683 79.6256 572.942 63.0272C591.607 76.0766 612.72 65.9392 620.943 59.2394C641.558 42.4438 634.964 26.6141 620.621 17.4883C612.276 12.1787 609.005 6.30298 607.252 1.88232C603.87 8.20016 601.42 19.0034 591.55 25.7504C586.652 29.0978 570.882 30.6494 562.666 33.2517C519.168 47.0288 526.232 93.6523 535.202 115.242Z",
    fill: "#223B41"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M535.366 113.884C532.68 119.96 530.691 135.067 546.577 138.769C548.367 144.574 556.414 157.022 574.271 160.37C596.592 164.555 612.083 161.351 619.335 155.08C626.587 148.808 635.565 132.738 635.412 118.131",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M627.34 117.661L638.445 116.074C640.3 114.27 643.748 107.366 635.911 106.09C633.062 105.841 626.697 104.448 624.019 100.87",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M620.715 59.0003C622.144 60.8101 624.899 65.6919 624.485 70.7401",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M585.429 94.8873C586.011 93.3677 587.912 89.7501 590.859 87.437",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 605.917,
    cy: 100.292,
    rx: 2,
    ry: 3,
    transform: "rotate(-4.51193 605.917 100.292)",
    fill: "#223B41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 632.808,
    cy: 85.1299,
    rx: 2,
    ry: 3,
    transform: "rotate(-4.51193 632.808 85.1299)",
    fill: "#223B41"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M611.558 101.853C612.177 109.7 607.33 115.729 601.654 116.177C595.978 116.625 590.245 111.43 589.626 103.584C589.007 95.7377 593.854 89.7085 599.53 89.2606C605.206 88.8127 610.939 94.0071 611.558 101.853Z",
    stroke: "#223B41",
    strokeWidth: 5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M636.376 85.8515C636.685 89.769 635.763 93.3139 634.142 95.872C632.522 98.4292 630.31 99.8721 627.967 100.057C625.624 100.242 623.213 99.1638 621.212 96.8923C619.21 94.6201 617.744 91.2637 617.435 87.3462C617.125 83.4287 618.047 79.8838 619.668 77.3257C621.288 74.7685 623.5 73.3256 625.843 73.1407C628.186 72.9558 630.597 74.0339 632.598 76.3054C634.6 78.5776 636.066 81.934 636.376 85.8515Z",
    stroke: "#223B41",
    strokeWidth: 5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M610.43 93.9176L617.094 89.3793",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M615.756 72.432C616.37 70.9661 618.363 68.024 621.424 67.9826",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M566.198 105.433L588.209 104.699",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M544.45 122.196C543.061 123.779 541.226 127.391 545.001 129.174",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M603.843 137.571C609.687 136.42 622.13 132.866 625.146 127.865",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M603.819 137.27C609.62 141.38 622.006 145.252 625.146 127.865",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M559.283 154.128C557.567 156.799 555.554 162.913 561.225 166C566.896 169.086 576.472 171.341 580.551 172.082C584.892 172.967 593.456 171.31 590.365 162.719",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M272.443 301.561C303.777 317.228 385.143 343.161 459.943 321.561M505.443 316.561C509.277 313.561 524.543 309.361 554.943 316.561C585.343 323.761 592.777 322.061 591.943 319.061C589.61 302.894 584.843 263.561 590.443 245.561C596.043 227.561 566.777 222.061 551.443 221.561C516.443 214.894 434.443 205.561 386.443 221.561C326.443 241.561 274.943 215.061 272.443 208.061",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M272.443 209.561C271.776 213.728 270.843 224.261 272.443 233.061M272.443 281.061C271.61 284.894 270.443 294.261 272.443 301.061",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M342.443 230.061C340.11 253.394 337.543 304.661 345.943 323.061M423.943 214.561C427.61 238.561 429.443 294.061 429.443 327.061M506.943 217.561C506.943 240.561 515.943 282.561 506.943 313.061",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44336 330L12.9434 349M18.9434 343V327M28.9434 343L37.9434 330",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M372.443 613.5L384.443 630.5M392.943 630.5V610M401.443 630.5L413.443 610",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M854.443 342.5L872.443 356.5M883.943 356.5V325M895.943 356.5L909.443 336",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.27 461.162L1033.46 474.407C1032.86 476.516 1033.68 478.824 1035.66 479.758C1043.57 483.483 1050.96 481.916 1055.49 479.733C1057.36 478.83 1058.05 476.636 1057.45 474.644L1053.49 461.431C1053.18 460.411 1052.57 459.493 1051.66 458.938C1046.2 455.602 1041.29 457.213 1038.69 459.013C1037.97 459.517 1037.51 460.31 1037.27 461.162Z",
    fill: "#223B41"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.44 520.772L1025.54 496C1042.22 505.636 1058.51 500.015 1064.57 496L1071.44 520.772C1050.15 533.863 1027.24 526.226 1018.44 520.772Z",
    fill: "#223B41"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.44 565.583L1012.02 542C1037.7 556.02 1067.87 547.842 1079.75 542L1087.44 565.583C1052.44 584.449 1016.86 573.444 1003.44 565.583Z",
    fill: "#223B41"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M996.019 582.598L1000.89 572.662C992.553 576.342 974.159 584.718 967.255 588.78C960.352 592.843 964.379 598.127 967.255 600.262C989.455 612.037 1035.05 636.339 1039.83 639.342C1044.61 642.345 1050.08 640.593 1052.22 639.342C1071.77 629.112 1113.16 607.239 1122.36 601.586C1131.57 595.934 1126.2 590.252 1122.36 588.118L1090.28 572L1095.15 581.273C1097.36 588.118 1091.97 592.092 1089.84 594.079C1059.21 616.865 1019.4 604.898 1003.32 596.066C995.002 591.121 994.987 585.027 996.019 582.598Z",
    fill: "#223B41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcMaintenance);
export default __webpack_public_path__ + "static/media/oc-maintenance.cf3be901f8e716fc2d9b79482adcd8dc.svg";
export { ForwardRef as ReactComponent };